import React, { useState, useEffect, useRef } from 'react';

var API = process.env.REACT_APP_API_URL || 'https://aizhi.fyi';

var COVER_COLORS = [
  { bg: '#f5e6e0', spine: '#e8c4b8', text: '#9a6b5a' },
  { bg: '#e0ecf5', spine: '#b8cce8', text: '#5a7a9a' },
  { bg: '#e8f0e0', spine: '#c0d8b0', text: '#5a8050' },
  { bg: '#f0e8f5', spine: '#d4c0e8', text: '#7a5a90' },
  { bg: '#fdf0e0', spine: '#f0d8b0', text: '#8a7040' },
  { bg: '#f5e0e8', spine: '#e8b8c8', text: '#905a6a' },
  { bg: '#e0f0f0', spine: '#b0d8d8', text: '#507878' },
  { bg: '#f0ece0', spine: '#d8ccb0', text: '#7a6a48' }
];

function getBookColor(bookId) {
  var hash = 0;
  var str = String(bookId);
  for (var i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash = hash & hash;
  }
  return COVER_COLORS[Math.abs(hash) % COVER_COLORS.length];
}

function BookShelf({ onSelectBook, onBack }) {
  var [books, setBooks] = useState([]);
  var [loading, setLoading] = useState(true);
  var [uploading, setUploading] = useState(false);
  var [editingId, setEditingId] = useState(null);
  var [editTitle, setEditTitle] = useState('');
  var [uploadProgress, setUploadProgress] = useState('');
  var [deleteConfirm, setDeleteConfirm] = useState(null);
  var fileInputRef = useRef(null);

  useEffect(function() { fetchBooks(); }, []);

  async function fetchBooks() {
    setLoading(true);
    try {
      var res = await fetch(API + '/api/books');
      var data = await res.json();
      setBooks(Array.isArray(data) ? data : []);
    } catch (e) { console.error('fetch books error:', e); }
    setLoading(false);
  }

  async function handleUpload(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    var ext = file.name.split('.').pop().toLowerCase();
    if (!['pdf', 'epub', 'txt'].includes(ext)) {
      alert('只支持 PDF / EPUB / TXT 格式');
      e.target.value = '';
      return;
    }
    setUploading(true);
    setUploadProgress('正在上传 ' + file.name + '...');
    try {
      var formData = new FormData();
      formData.append('file', file);
      var res = await fetch(API + '/api/books/upload', { method: 'POST', body: formData });
      var data = await res.json();
      if (data.success) {
        setUploadProgress('上传成功！');
        fetchBooks();
        setTimeout(function() { setUploadProgress(''); }, 1500);
      } else {
        setUploadProgress('');
        alert(data.error || '上传失败');
      }
    } catch (err) {
      setUploadProgress('');
      alert('上传失败: ' + err.message);
    }
    setUploading(false);
    e.target.value = '';
  }

  async function handleRename(bookId) {
    if (!editTitle.trim()) { setEditingId(null); return; }
    try {
      var res = await fetch(API + '/api/books/' + bookId, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title: editTitle.trim() })
      });
      if (res.ok) {
        setBooks(function(prev) {
          return prev.map(function(b) {
            return b.id === bookId ? Object.assign({}, b, { title: editTitle.trim() }) : b;
          });
        });
      }
    } catch (e) { console.error('rename error:', e); }
    setEditingId(null);
    setEditTitle('');
  }

  async function handleDelete(bookId) {
    try {
      await fetch(API + '/api/books/' + bookId, { method: 'DELETE' });
      setBooks(function(prev) { return prev.filter(function(b) { return b.id !== bookId; }); });
    } catch (e) { console.error('delete error:', e); }
    setDeleteConfirm(null);
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    try {
      var d = new Date(dateStr);
      return (d.getMonth() + 1) + '月' + d.getDate() + '日';
    } catch (e) { return ''; }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#faf8f5', paddingBottom: 80 }}>
      {/* 顶部导航 */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 20,
        background: 'rgba(250,248,245,0.92)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(0,0,0,0.04)', padding: '0 16px', paddingTop: 'env(safe-area-inset-top, 0px)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 52 }}>
          <div onClick={function() { if (onBack) onBack(); else window.history.back(); }} style={{ fontSize: 14, color: '#8c7b6b', cursor: 'pointer', padding: '6px 4px', display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ fontSize: 16 }}>‹</span><span>返回</span>
          </div>
          <div style={{ fontSize: 16, fontWeight: 600, color: '#2d2418', letterSpacing: 1 }}>共读书架</div>
          <div onClick={function() { if (!uploading && fileInputRef.current) fileInputRef.current.click(); }}
            style={{ width: 34, height: 34, borderRadius: 10, background: '#ebe5dc', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: uploading ? 'wait' : 'pointer', fontSize: 18, color: '#8c7b6b' }}>
            {uploading ? '⏳' : '+'}
          </div>
        </div>
      </div>

      {/* 隐藏的文件选择器 */}
      <input ref={fileInputRef} type="file" accept=".pdf,.epub,.txt" onChange={handleUpload} disabled={uploading} style={{ display: 'none' }} />
      {uploadProgress && <div style={{ textAlign: 'center', padding: '8px', fontSize: 13, color: '#80CBC4' }}>{uploadProgress}</div>}

      {/* 副标题 */}
      <div style={{ textAlign: 'center', padding: '12px 20px 2px' }}>
        <div style={{ fontSize: 13, color: '#b5a99a', letterSpacing: 3, fontStyle: 'italic' }}>你划你的线，我划我的线</div>
      </div>

      {/* 书籍网格 */}
      <div style={{ padding: '16px 20px 0', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 16 }}>
        {loading ? (
          <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '50px 20px', color: '#b5a99a', fontSize: 14 }}>加载中...</div>
        ) : books.length === 0 ? (
          <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '50px 20px', color: '#b5a99a', fontSize: 14 }}>还没有书</div>
        ) : (
          books.map(function(book) {
            var color = getBookColor(book.id);
            var isEditing = editingId === book.id;
            var isDeleting = deleteConfirm === book.id;

            return (
              <div key={book.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {/* 书本封面 */}
                <div
                  onClick={function() { if (!isEditing && !isDeleting) onSelectBook(book); }}
                  style={{
                    width: '100%', aspectRatio: '3/4.2', borderRadius: 6, position: 'relative', cursor: 'pointer', transition: 'transform 0.2s',
                    background: color.bg,
                    boxShadow: '6px 6px 12px rgba(0,0,0,0.15), 2px 2px 4px rgba(0,0,0,0.08)',
                    display: 'flex', flexDirection: 'column', overflow: 'hidden'
                  }}
                >
                  {/* 书名区域——靠上三分之一，水平居中 */}
                  <div style={{ padding: '22px 16px 0', textAlign: 'center' }}>
                    <div style={{
                      fontSize: 20, fontWeight: 600, color: color.text, lineHeight: 1.5,
                      fontFamily: '"Noto Serif SC", "Songti SC", "SimSun", serif',
                      display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden', wordBreak: 'break-all'
                    }}>{book.title}</div>
                  </div>

                  {/* 底部信息 */}
                  <div style={{ flex: 1 }} />
                  <div style={{ padding: '0 14px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 9, color: color.text, opacity: 0.4 }}>{book.total_chunks} 页</span>
                    <span style={{ fontSize: 9, color: color.text, opacity: 0.4 }}>{formatDate(book.created_at)}</span>
                  </div>
                </div>

                {/* 书名 + 操作 */}
                <div style={{ width: '100%', marginTop: 8, textAlign: 'center' }}>
                  {isEditing ? (
                    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                      <input
                        value={editTitle} onChange={function(e) { setEditTitle(e.target.value); }}
                        onKeyDown={function(e) { if (e.key === 'Enter') handleRename(book.id); if (e.key === 'Escape') { setEditingId(null); setEditTitle(''); } }}
                        autoFocus
                        style={{ flex: 1, padding: '6px 8px', border: '1px solid var(--accent)', borderRadius: 6, fontSize: 12, background: '#fff', color: '#2d2418', outline: 'none', fontFamily: 'inherit', minWidth: 0 }}
                      />
                      <button onClick={function() { handleRename(book.id); }} style={{ padding: '6px 10px', borderRadius: 6, border: 'none', background: 'var(--accent)', color: '#fff', fontSize: 11, cursor: 'pointer' }}>✓</button>
                    </div>
                  ) : isDeleting ? (
                    <div style={{ fontSize: 11, color: '#c46060' }}>
                      <div style={{ marginBottom: 6 }}>确定删除？</div>
                      <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                        <button onClick={function() { handleDelete(book.id); }} style={{ padding: '4px 14px', borderRadius: 6, border: 'none', background: '#e85050', color: '#fff', fontSize: 11, cursor: 'pointer' }}>删除</button>
                        <button onClick={function() { setDeleteConfirm(null); }} style={{ padding: '4px 14px', borderRadius: 6, border: 'none', background: '#ebe5dc', color: '#8c7b6b', fontSize: 11, cursor: 'pointer' }}>取消</button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 500, color: '#2d2418', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: 4 }}>{book.title}</div>
                      <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                        <span onClick={function(e) { e.stopPropagation(); setEditingId(book.id); setEditTitle(book.title); }} style={{ fontSize: 11, color: '#b5a99a', cursor: 'pointer' }}>改名</span>
                        <span style={{ color: '#ddd' }}>|</span>
                        <span onClick={function(e) { e.stopPropagation(); setDeleteConfirm(book.id); }} style={{ fontSize: 11, color: '#d4a0a0', cursor: 'pointer' }}>删除</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>

      {books.length > 0 && (
        <div style={{ textAlign: 'center', padding: '24px', fontSize: 11, color: '#d4ccc0' }}>共 {books.length} 本书</div>
      )}
    </div>
  );
}

export default BookShelf;
